import { UserAuthorizationLevel } from "Store/advice/interfaces";
import {
  CoverageNeed,
  ProductCoverageName,
  PurchaseRestrictionReason,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { getPayment } from "Store/akaAdvice/interfaces/getters";

export const isRecommendedPensionRestrictedByMaxProductPayment = (
  need: CoverageNeed,
): boolean => {
  const { restrictions, advice } = getPayment(
    need,
    ProductCoverageName.DISABILITY_FLEX_PENSION,
  );
  const maxPayment =
    restrictions.paymentRestriction.maxPayouts[
      UserAuthorizationLevel.PRODUCT_MANAGER
    ];
  return (
    advice.recommended === maxPayment &&
    !restrictions.restrictionReasons.includes(PurchaseRestrictionReason.INCOME)
  );
};
